import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

type Props = {
  title: string;
  description?: string;
  visible: boolean;
};

export default function PopupLoading(props: Props) {
  return (
    <div>
      <Dialog
        open={props.visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description}
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
